import { SVGPureIcon } from '@/ui';
import './index.scss';
import globalStore from '@/store/global';

function StopButton(props) {
  const { className, onClick } = props;
  return (
    <button
      className={[
        'rounded-full cursor-pointer flex justify-center items-center',
        globalStore.isDark ? '!bg-[#fff] !hover:bg-[#ffffffE6]':'bg-[#000] hover:bg-[#222]',
        className,
      ]}
      onClick={event => onClick?.(event)}
    >
      <div className={`bg-[#fff] size-12px rounded-4px ${globalStore.isDark ? '!bg-[#282832]':''}`}></div>
    </button>
  );
}

export default StopButton;
